export default {"src":"https://fishbrain.com/_next/static/media/spotPredictions.e29ec73e.svg","height":36,"width":46,"blurWidth":0,"blurHeight":0};